import { api } from "api/api";
import { AxiosError } from "axios";
import RequisitoAuditoria from "model/auditoria5s/requisitoAuditoria/RequisitoAuditoria";
import PlanoAuditoria from "model/auditoria5s/planoDeAuditoria/PlanoAuditoria";
import Page from "model/page/Page";
import Pageable from "model/page/Pageable";
import { BaseServiceCadastros } from "service/BaseServiceCadastros";
import { generateKey } from "utils/generateKey";
import { DataTableFilterMeta } from "primereact/datatable";
import { getFilters } from "utils/filterUtils";

class PlanoAuditoriaService implements BaseServiceCadastros<PlanoAuditoria> {

    pesquisar(page: Pageable, filters?: DataTableFilterMeta | null) {
        return new Promise<Page>((resolve, reject): void => {
            let url = `/planoAuditoria/pesquisar`;
            url += getFilters(filters);
            const params = {
                page: page.page,
                size: page.size,
                sort: page.sort,
            };

            api
                .get(url, { params })
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    consultar(id: number) {
        return new Promise<PlanoAuditoria>((resolve, reject): void => {
            api
                .get(`/planoAuditoria/consultar/${id}`)
                .then(response => {
                    const planoAuditoria: PlanoAuditoria = response.data;
                    planoAuditoria.classes.forEach(classe => {
                        classe.key = generateKey();
                        classe.itensPlanoAuditoria.forEach(item => {
                            item.key = generateKey();
                            return item;
                        });
                        return classe;
                    });
                    return resolve(planoAuditoria);
                })
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    consultarRequisitos() {
        return new Promise<RequisitoAuditoria[]>((resolve, reject): void => {
            api
                .get(`/planoAuditoria/requisitos`)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    planos(){
        return new Promise<PlanoAuditoria[]>((resolve, reject): void => {
            api
                .get(`/planoAuditoria/all`)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    incluir(planoAuditoria: PlanoAuditoria) {
        return new Promise<PlanoAuditoria>((resolve, reject): void => {
            api
                .post(`/planoAuditoria/incluir`, JSON.stringify(planoAuditoria))
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    editar(planoAuditoria: PlanoAuditoria) {
        return new Promise<PlanoAuditoria>((resolve, reject): void => {
            api
                .put(`/planoAuditoria/editar`, JSON.stringify(planoAuditoria))
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    excluir(id: number) {
        return new Promise<void>((resolve, reject): void => {
            api
                .delete(`/planoAuditoria/excluir/${id}`)
                .then(() => resolve())
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    getRelatorio(id: number) {

        return new Promise<string>((resolve, reject): void => {
            api
                .get(`/planoAuditoria/report/${id}`, { responseType: 'arraybuffer' })
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

}

export default PlanoAuditoriaService;
